import { createDate, set } from '@lingoda/dates';
import { type ClockInterval } from '@lingoda/clock';
import { useIntervalState } from '../useIntervalState';

interface Options {
    round?: boolean;
    /**
     * Return the real current instant (`new Date()`) instead of the profile-zone wall time
     * (`createDate()`). Use it to compare with instantDate() values (class start/end).
     */
    useInstant?: boolean;
}

export const useIntervalDate = (
    clockInterval: ClockInterval,
    { round, useInstant }: Options = {},
) => {
    const [now] = useIntervalState<Date>(() => {
        const date = useInstant ? new Date() : createDate();

        if (round) {
            switch (clockInterval) {
                case 'hour':
                    return set({ minutes: 0, seconds: 0, milliseconds: 0 }, date);
                case 'minute':
                    return set({ seconds: 0, milliseconds: 0 }, date);
                case 'second':
                    return set({ milliseconds: 0 }, date);
                default:
                    return date;
            }
        }

        return date;
    }, clockInterval);

    return now;
};
